// antd renders no pagination at a total of 0, so without the floor the bar would disappear before the first page loads and on an empty result
export function toAntdPaginationTotal(total: number): number {
  return Math.max(total, 1);
}
